import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseSendOtpWithEmailRedirectRepository } from '@/modules/auth/infra/repositories'
import type { SendOtpWithEmailRedirect } from '@/modules/auth/use-cases'

export function makeSendOtpWithEmailRedirect(): SendOtpWithEmailRedirect {
  return new SupabaseSendOtpWithEmailRedirectRepository(makeSupabaseClient()).execute
}
